import React from 'react';

import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import PickupOrder from '../../../models/PickupOrder';
import PickupOrderListItem from '../../../models/PickupOrderListItem';

import tableIcons from '../../../utils/editTableIcons';

import pickupOrderStyles from '../../pickupOrder/pickupOrder.module.css';
import commonStyles from '../../common/common.module.css';

interface CommonOrderTableProps {
  pickupOrder: PickupOrder;
};

const commonOrderTableTrc = (props: CommonOrderTableProps) => {

  const { pickupOrder } = props;
  
  return (
    <div className={ pickupOrderStyles.tableWrapper }>
      <MaterialTable

        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
        
        icons={ tableIcons }

        data = { pickupOrder.list }

        columns = {[
          { title: 'Airwaybill', field: '', cellStyle: { color: 'rgb(0, 50, 97', width: '120px', verticalAlign: 'baseline'},
            render: (rowData: PickupOrderListItem) => {

              return <span>{ rowData.code }-{ rowData.number } {rowData.returned? <span className={pickupOrderStyles.returnToDriverText}>Returned to driver</span>: null}</span>;
            }
          },
          { title: 'Pcs', field: 'pieces', cellStyle: { color: 'rgb(0, 50, 97', verticalAlign: 'baseline'}},
          { title: 'Wgt', field: 'weight', cellStyle: { color: 'rgb(0, 50, 97', verticalAlign: 'baseline'},
            render: (rowData: PickupOrderListItem) => {

              return `${rowData.weight}K`;
            }
          },
          { title: 'Remarks', field: 'remarks_text', cellStyle: { color: 'rgb(0, 50, 97',verticalAlign: 'baseline'}}
        ]}

        options = {{
          search: false,
          paging: false,
          showTitle: false,
          actionsColumnIndex: -1,
          toolbar: false,
          sorting: false,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          }                
        }}
      />
    </div>
  );
}

export default commonOrderTableTrc;